import { fromJS, Map as ImmutableMap } from 'immutable';
import type { Reducer } from 'redux';

import type { TypedMap } from 'utils/typed-map';

import { ADD, ADD_MULTIPLE, REMOVE } from './constants';
import type DonationSchedule from './model';

export type DonationScheduleMap = ImmutableMap<string, DonationSchedule>;

export type DonationScheduleState = TypedMap<{
  donationSchedules: DonationScheduleMap;
}>;

export const initialState: DonationScheduleState = fromJS({
  donationSchedules: ImmutableMap(),
});

const donationScheduleReducer: Reducer = (state = initialState, action): DonationScheduleState => {
  switch (action.type) {
    case ADD:
      return state.set(
        'donationSchedules',
        state.get('donationSchedules').set(action.donationSchedule.id, action.donationSchedule)
      );

    case ADD_MULTIPLE:
      return state.set(
        'donationSchedules',
        state.get('donationSchedules').merge(action.donationSchedules)
      );

    case REMOVE:
      return state.set('donationSchedules', state.get('donationSchedules').remove(action.id));

    default:
      return state;
  }
};
export default donationScheduleReducer;
